var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileDarkFillIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 25 24",
    style: {
      enableBackground: "new 0 0 25 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#1c3f88}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.5 15.5c-1.8 0-3.6.5-5.1 1.3-1.5.9-2.6 2.1-3.1 3.5-.1.3 0 .5.3.6H20.4c.3-.1.4-.4.3-.6-.5-1.4-1.6-2.6-3.1-3.5-1.5-.8-3.3-1.3-5.1-1.3zM12.5 3.5C10 3.5 8 5.5 8 8s2 4.5 4.5 4.5S17 10.5 17 8s-2-4.5-4.5-4.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileDarkFillIcon);
export default __webpack_public_path__ + "static/media/profile-dark-fill-icon.cd912c0b87306b7e373c334343f3ca9a.svg";
export { ForwardRef as ReactComponent };